/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Brands API
 * API for managing beauty brands and brand information
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Get all brands with optional filtering
 */
export const getBrandsQuerySearchMax = 100;

export const getBrandsQueryBrandIndexItemMax = 5;

export const getBrandsQueryBrandListShowAllDefault = false;
export const getBrandsQueryMinRatingMin = 0;
export const getBrandsQueryMinRatingMax = 5;

export const getBrandsQueryPageDefault = 1;

export const getBrandsQueryPerPageDefault = 192;
export const getBrandsQueryPerPageMax = 10000;

export const GetBrandsQueryParams = zod
    .object({
        search: zod
            .string()
            .max(getBrandsQuerySearchMax)
            .optional()
            .describe("Search keyword for brand name or description"),
        country: zod.array(zod.string()).optional().describe("Filter by country"),
        brand_index: zod
            .array(zod.string().max(getBrandsQueryBrandIndexItemMax))
            .optional()
            .describe("Filter by brand index (0-9, A-Z, Other)"),
        brand_list_show_all: zod
            .boolean()
            .default(getBrandsQueryBrandListShowAllDefault)
            .describe("Include brands with no registered products"),
        priority: zod
            .union([zod.literal(1), zod.literal(2), zod.literal(3), zod.literal(4), zod.literal(5), zod.literal(9)])
            .optional()
            .describe("Filter by brand display priority"),
        brand_status: zod
            .enum(["draft", "editing", "released", "duplicated", "rejected"])
            .optional()
            .describe("Filter by brand status (admin\/editor only — ignored for other roles)"),
        min_rating: zod
            .number()
            .min(getBrandsQueryMinRatingMin)
            .max(getBrandsQueryMinRatingMax)
            .optional()
            .describe("Filter by minimum average rating"),
        recommend_only: zod
            .union([zod.literal(0), zod.literal(1)])
            .optional()
            .describe("Filter to recommended brands only (based on recommend rank)"),
        page: zod.number().min(1).default(getBrandsQueryPageDefault).describe("Page number for pagination"),
        per_page: zod
            .number()
            .min(1)
            .max(getBrandsQueryPerPageMax)
            .default(getBrandsQueryPerPageDefault)
            .describe("Number of items per page"),
    })
    .strict();

export const getBrands200ResponseDataItemBrandIndexMax = 5;

export const getBrands200ResponseDataItemBrandNameMax = 100;

export const getBrands200ResponseDataItemCountryMax = 100;

export const getBrands200ResponseDataItemWebsiteMax = 1024;

export const getBrands200ResponseDataItemFacebookMax = 1024;

export const getBrands200ResponseDataItemInstagramMax = 255;

export const getBrands200ResponseDataItemYoutubeMax = 1024;

export const getBrands200ResponseDataItemTiktokMax = 1024;

export const getBrands200ResponseDataItemXMax = 1024;

export const GetBrands200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        data: zod
            .array(
                zod
                    .object({
                        brand_id: zod.number().nullable().describe("Unique brand identifier (numeric)"),
                        brand_note: zod
                            .string()
                            .optional()
                            .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
                        brand_index: zod
                            .string()
                            .max(getBrands200ResponseDataItemBrandIndexMax)
                            .describe("Alphabetical index for sorting (0-9, A-Z)"),
                        brand_name: zod.string().max(getBrands200ResponseDataItemBrandNameMax).describe("Brand name"),
                        brand_status: zod
                            .enum(["draft", "editing", "released", "duplicated", "rejected"])
                            .optional()
                            .describe("Brand status"),
                        created_by: zod.number().nullish().describe("User ID who created this brand (audit)"),
                        updated_by: zod.number().nullish().describe("User ID who last updated this brand (audit)"),
                        created_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Brand created timestamp (audit)"),
                        updated_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Brand last updated timestamp (audit)"),
                        image_url: zod.string().optional().describe("Brand logo image URL"),
                        brand_description_th: zod.string().optional().describe("Brand description in Thai"),
                        brand_description_en: zod.string().optional().describe("Brand description in English"),
                        brand_description_ja: zod.string().optional().describe("Brand description in Japanese"),
                        review_count: zod.number().nullish().describe("Total number of reviews for this brand"),
                        review_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing review_count — excludes reviews on products a guest can't browse to (draft\/rejected\/dummy\/duplicated\/brand-placeholder, same basis as products_count_guest). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        posts_count: zod
                            .number()
                            .nullish()
                            .describe(
                                "Total number of posts across all of this brand's products, across all board types (review, articles, tiktoks) — not just reviews. Admin\/editor-facing (unfiltered).",
                            ),
                        posts_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing posts_count — excludes posts on products a guest can't browse to (same basis as products_count_guest). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        products_count: zod
                            .number()
                            .optional()
                            .describe(
                                "Total number of products for this brand whose status an admin\/editor can browse to (excludes only the brand-placeholder status). Pre-computed by the brands:update-products-count batch.",
                            ),
                        products_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing products_count — narrower, also excludes draft\/rejected\/dummy\/duplicated statuses a guest can't browse to. Pre-computed by the brands:update-products-count batch (ISS-01-190).",
                            ),
                        average_rating: zod.number().nullish().describe("Average rating score (null if no ratings)"),
                        activate_time: zod
                            .string()
                            .datetime({ offset: true })
                            .nullish()
                            .describe("Brand activation timestamp (null if not activated)"),
                        priority: zod
                            .union([
                                zod.literal(1),
                                zod.literal(2),
                                zod.literal(3),
                                zod.literal(4),
                                zod.literal(5),
                                zod.literal(9),
                            ])
                            .optional()
                            .describe("Display priority (higher = more prominent)"),
                        country: zod
                            .string()
                            .max(getBrands200ResponseDataItemCountryMax)
                            .optional()
                            .describe("Brand origin country"),
                        website: zod
                            .string()
                            .max(getBrands200ResponseDataItemWebsiteMax)
                            .optional()
                            .describe("Official brand website URL"),
                        facebook: zod
                            .string()
                            .max(getBrands200ResponseDataItemFacebookMax)
                            .optional()
                            .describe("Facebook page username or ID"),
                        instagram: zod
                            .string()
                            .max(getBrands200ResponseDataItemInstagramMax)
                            .optional()
                            .describe("Instagram username"),
                        youtube: zod
                            .string()
                            .max(getBrands200ResponseDataItemYoutubeMax)
                            .optional()
                            .describe("YouTube channel URL (null if not available)"),
                        tiktok: zod
                            .string()
                            .max(getBrands200ResponseDataItemTiktokMax)
                            .optional()
                            .describe("TikTok profile URL (null if not available)"),
                        x: zod
                            .string()
                            .max(getBrands200ResponseDataItemXMax)
                            .optional()
                            .describe("X profile URL or username (null if not available)"),
                        brand_video_post_ids: zod
                            .array(zod.number())
                            .nullish()
                            .describe("Post IDs with video\/SNS media linked to this brand (batch-updated pool)"),
                        recommend_rank: zod.number().nullish().describe("Recommend rank (null if not recommended)"),
                    })
                    .strict(),
            )
            .optional(),
        pagination: zod
            .object({
                current_page: zod.number().optional(),
                total: zod.number().optional(),
                per_page: zod.number().optional(),
                last_page: zod.number().optional(),
            })
            .strict()
            .optional()
            .describe("Matches ApiControllerBase::jsonPaginated()'s actual response shape."),
    })
    .strict();

export const GetBrands400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();

export const GetBrands500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Create brand (admin/editor only)
 */
export const createItemBodyBrandNameMax = 100;

export const createItemBodyBrandStatusDefault = `draft`;
export const createItemBodyBrandIndexMax = 5;

export const createItemBodyImageUrlMax = 1024;

export const createItemBodyCountryMax = 100;

export const createItemBodyWebsiteMax = 1024;

export const createItemBodyFacebookMax = 1024;

export const createItemBodyInstagramMax = 255;

export const createItemBodyYoutubeMax = 1024;

export const createItemBodyTiktokMax = 1024;

export const createItemBodyXMax = 1024;

export const createItemBodyPriorityDefault = 2;

export const CreateItemBody = zod
    .object({
        brand_name: zod.string().max(createItemBodyBrandNameMax),
        brand_status: zod
            .enum(["draft", "editing", "released", "duplicated", "rejected"])
            .default(createItemBodyBrandStatusDefault)
            .describe("Brand status"),
        brand_index: zod.string().max(createItemBodyBrandIndexMax),
        brand_note: zod
            .string()
            .optional()
            .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
        image_url: zod.string().max(createItemBodyImageUrlMax).optional(),
        country: zod.string().max(createItemBodyCountryMax).optional(),
        website: zod.string().max(createItemBodyWebsiteMax).optional(),
        facebook: zod.string().max(createItemBodyFacebookMax).optional(),
        instagram: zod.string().max(createItemBodyInstagramMax).optional(),
        youtube: zod.string().max(createItemBodyYoutubeMax).optional(),
        tiktok: zod.string().max(createItemBodyTiktokMax).optional(),
        x: zod.string().max(createItemBodyXMax).optional(),
        priority: zod
            .union([zod.literal(1), zod.literal(2), zod.literal(3), zod.literal(4), zod.literal(5), zod.literal(9)])
            .default(createItemBodyPriorityDefault),
        activate_time: zod.string().datetime({ offset: true }).nullish(),
        brand_description_th: zod.string().optional(),
        brand_description_en: zod.string().optional(),
        brand_description_ja: zod.string().optional(),
    })
    .strict();

export const createItem201ResponseDataItemBrandIndexMax = 5;

export const createItem201ResponseDataItemBrandNameMax = 100;

export const createItem201ResponseDataItemCountryMax = 100;

export const createItem201ResponseDataItemWebsiteMax = 1024;

export const createItem201ResponseDataItemFacebookMax = 1024;

export const createItem201ResponseDataItemInstagramMax = 255;

export const createItem201ResponseDataItemYoutubeMax = 1024;

export const createItem201ResponseDataItemTiktokMax = 1024;

export const createItem201ResponseDataItemXMax = 1024;

export const CreateItem201Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .object({
                        brand_id: zod.number().nullable().describe("Unique brand identifier (numeric)"),
                        brand_note: zod
                            .string()
                            .optional()
                            .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
                        brand_index: zod
                            .string()
                            .max(createItem201ResponseDataItemBrandIndexMax)
                            .describe("Alphabetical index for sorting (0-9, A-Z)"),
                        brand_name: zod.string().max(createItem201ResponseDataItemBrandNameMax).describe("Brand name"),
                        brand_status: zod
                            .enum(["draft", "editing", "released", "duplicated", "rejected"])
                            .optional()
                            .describe("Brand status"),
                        created_by: zod.number().nullish().describe("User ID who created this brand (audit)"),
                        updated_by: zod.number().nullish().describe("User ID who last updated this brand (audit)"),
                        created_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Brand created timestamp (audit)"),
                        updated_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Brand last updated timestamp (audit)"),
                        image_url: zod.string().optional().describe("Brand logo image URL"),
                        brand_description_th: zod.string().optional().describe("Brand description in Thai"),
                        brand_description_en: zod.string().optional().describe("Brand description in English"),
                        brand_description_ja: zod.string().optional().describe("Brand description in Japanese"),
                        review_count: zod.number().nullish().describe("Total number of reviews for this brand"),
                        review_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing review_count — excludes reviews on products a guest can't browse to (draft\/rejected\/dummy\/duplicated\/brand-placeholder, same basis as products_count_guest). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        posts_count: zod
                            .number()
                            .nullish()
                            .describe(
                                "Total number of posts across all of this brand's products, across all board types (review, articles, tiktoks) — not just reviews. Admin\/editor-facing (unfiltered).",
                            ),
                        posts_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing posts_count — excludes posts on products a guest can't browse to (same basis as products_count_guest). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        products_count: zod
                            .number()
                            .optional()
                            .describe(
                                "Total number of products for this brand whose status an admin\/editor can browse to (excludes only the brand-placeholder status). Pre-computed by the brands:update-products-count batch.",
                            ),
                        products_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing products_count — narrower, also excludes draft\/rejected\/dummy\/duplicated statuses a guest can't browse to. Pre-computed by the brands:update-products-count batch (ISS-01-190).",
                            ),
                        average_rating: zod.number().nullish().describe("Average rating score (null if no ratings)"),
                        activate_time: zod
                            .string()
                            .datetime({ offset: true })
                            .nullish()
                            .describe("Brand activation timestamp (null if not activated)"),
                        priority: zod
                            .union([
                                zod.literal(1),
                                zod.literal(2),
                                zod.literal(3),
                                zod.literal(4),
                                zod.literal(5),
                                zod.literal(9),
                            ])
                            .optional()
                            .describe("Display priority (higher = more prominent)"),
                        country: zod
                            .string()
                            .max(createItem201ResponseDataItemCountryMax)
                            .optional()
                            .describe("Brand origin country"),
                        website: zod
                            .string()
                            .max(createItem201ResponseDataItemWebsiteMax)
                            .optional()
                            .describe("Official brand website URL"),
                        facebook: zod
                            .string()
                            .max(createItem201ResponseDataItemFacebookMax)
                            .optional()
                            .describe("Facebook page username or ID"),
                        instagram: zod
                            .string()
                            .max(createItem201ResponseDataItemInstagramMax)
                            .optional()
                            .describe("Instagram username"),
                        youtube: zod
                            .string()
                            .max(createItem201ResponseDataItemYoutubeMax)
                            .optional()
                            .describe("YouTube channel URL (null if not available)"),
                        tiktok: zod
                            .string()
                            .max(createItem201ResponseDataItemTiktokMax)
                            .optional()
                            .describe("TikTok profile URL (null if not available)"),
                        x: zod
                            .string()
                            .max(createItem201ResponseDataItemXMax)
                            .optional()
                            .describe("X profile URL or username (null if not available)"),
                        brand_video_post_ids: zod
                            .array(zod.number())
                            .nullish()
                            .describe("Post IDs with video\/SNS media linked to this brand (batch-updated pool)"),
                        recommend_rank: zod.number().nullish().describe("Recommend rank (null if not recommended)"),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const CreateItem401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const CreateItem403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const CreateItem409Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const CreateItem422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const CreateItem500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * Used by the rank selection popup to disable already-used ranks (admin/editor only).
 * @summary Get recommend meta (used ranks, current rank)
 */
export const GetBrandRecommendMetaParams = zod
    .object({
        brand_id: zod.number().nullable().describe("Brand ID"),
    })
    .strict();

export const getBrandRecommendMeta200ResponseDataCurrentRankMax = 15;

export const GetBrandRecommendMeta200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                brand_id: zod.number().nullable(),
                max_rank: zod.number(),
                current_rank: zod.number().min(1).max(getBrandRecommendMeta200ResponseDataCurrentRankMax).nullable(),
                used_ranks: zod.array(zod.number()),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetBrandRecommendMeta401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const GetBrandRecommendMeta403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const GetBrandRecommendMeta404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const GetBrandRecommendMeta500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

/**
 * Set or update recommend rank. Rank can be null (admin/editor only).
 * @summary Set/update recommend rank
 */
export const UpsertBrandRecommendParams = zod
    .object({
        brand_id: zod.number().nullable().describe("Brand ID"),
    })
    .strict();

export const upsertBrandRecommendBodyRankMax = 15;

export const UpsertBrandRecommendBody = zod
    .object({
        rank: zod.number().min(1).max(upsertBrandRecommendBodyRankMax).optional(),
    })
    .strict();

export const upsertBrandRecommend200ResponseDataRankMax = 15;

export const UpsertBrandRecommend200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                brand_id: zod.number().nullable(),
                rank: zod.number().min(1).max(upsertBrandRecommend200ResponseDataRankMax),
            })
            .strict()
            .optional(),
    })
    .strict();

export const UpsertBrandRecommend400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UpsertBrandRecommend401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UpsertBrandRecommend403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UpsertBrandRecommend404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UpsertBrandRecommend409Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UpsertBrandRecommend422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UpsertBrandRecommend500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

/**
 * Remove recommend entry for the brand (admin/editor only).
 * @summary Unset recommend
 */
export const RemoveBrandRecommendParams = zod
    .object({
        brand_id: zod.number().nullable().describe("Brand ID"),
    })
    .strict();

export const RemoveBrandRecommend200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                brand_id: zod.number().nullable(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const RemoveBrandRecommend400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const RemoveBrandRecommend401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const RemoveBrandRecommend403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const RemoveBrandRecommend404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const RemoveBrandRecommend500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

/**
 * Auto-detects merge-target candidates by parsing brand_id references out of this brand's brand_note (written by master:mark-duplicates — see StatusNoteHelper::appendDuplicateNote()). Returns the source brand itself plus each candidate's full record, for the merge tool modal's two-column comparison.
 * @summary Merge-target candidates for a duplicated brand (admin/editor only)
 */
export const GetBrandMergeCandidatesParams = zod
    .object({
        brand_id: zod.number().nullable(),
    })
    .strict();

export const GetBrandMergeCandidatesQueryParams = zod
    .object({
        target_id: zod
            .number()
            .optional()
            .describe(
                "Admin-typed brand_id to include as a merge-target candidate even if it wasn't auto-detected from brand_note.",
            ),
    })
    .strict();

export const getBrandMergeCandidates200ResponseDataSourceBrandIndexMax = 5;

export const getBrandMergeCandidates200ResponseDataSourceBrandNameMax = 100;

export const getBrandMergeCandidates200ResponseDataSourceCountryMax = 100;

export const getBrandMergeCandidates200ResponseDataSourceWebsiteMax = 1024;

export const getBrandMergeCandidates200ResponseDataSourceFacebookMax = 1024;

export const getBrandMergeCandidates200ResponseDataSourceInstagramMax = 255;

export const getBrandMergeCandidates200ResponseDataSourceYoutubeMax = 1024;

export const getBrandMergeCandidates200ResponseDataSourceTiktokMax = 1024;

export const getBrandMergeCandidates200ResponseDataSourceXMax = 1024;

export const getBrandMergeCandidates200ResponseDataCandidatesItemBrandIndexMax = 5;

export const getBrandMergeCandidates200ResponseDataCandidatesItemBrandNameMax = 100;

export const getBrandMergeCandidates200ResponseDataCandidatesItemCountryMax = 100;

export const getBrandMergeCandidates200ResponseDataCandidatesItemWebsiteMax = 1024;

export const getBrandMergeCandidates200ResponseDataCandidatesItemFacebookMax = 1024;

export const getBrandMergeCandidates200ResponseDataCandidatesItemInstagramMax = 255;

export const getBrandMergeCandidates200ResponseDataCandidatesItemYoutubeMax = 1024;

export const getBrandMergeCandidates200ResponseDataCandidatesItemTiktokMax = 1024;

export const getBrandMergeCandidates200ResponseDataCandidatesItemXMax = 1024;

export const GetBrandMergeCandidates200Response = zod
    .object({
        data: zod
            .object({
                source: zod
                    .object({
                        brand_id: zod.number().nullable().describe("Unique brand identifier (numeric)"),
                        brand_note: zod
                            .string()
                            .optional()
                            .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
                        brand_index: zod
                            .string()
                            .max(getBrandMergeCandidates200ResponseDataSourceBrandIndexMax)
                            .describe("Alphabetical index for sorting (0-9, A-Z)"),
                        brand_name: zod
                            .string()
                            .max(getBrandMergeCandidates200ResponseDataSourceBrandNameMax)
                            .describe("Brand name"),
                        brand_status: zod
                            .enum(["draft", "editing", "released", "duplicated", "rejected"])
                            .optional()
                            .describe("Brand status"),
                        created_by: zod.number().nullish().describe("User ID who created this brand (audit)"),
                        updated_by: zod.number().nullish().describe("User ID who last updated this brand (audit)"),
                        created_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Brand created timestamp (audit)"),
                        updated_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Brand last updated timestamp (audit)"),
                        image_url: zod.string().optional().describe("Brand logo image URL"),
                        brand_description_th: zod.string().optional().describe("Brand description in Thai"),
                        brand_description_en: zod.string().optional().describe("Brand description in English"),
                        brand_description_ja: zod.string().optional().describe("Brand description in Japanese"),
                        review_count: zod.number().nullish().describe("Total number of reviews for this brand"),
                        review_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing review_count — excludes reviews on products a guest can't browse to (draft\/rejected\/dummy\/duplicated\/brand-placeholder, same basis as products_count_guest). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        posts_count: zod
                            .number()
                            .nullish()
                            .describe(
                                "Total number of posts across all of this brand's products, across all board types (review, articles, tiktoks) — not just reviews. Admin\/editor-facing (unfiltered).",
                            ),
                        posts_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing posts_count — excludes posts on products a guest can't browse to (same basis as products_count_guest). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        products_count: zod
                            .number()
                            .optional()
                            .describe(
                                "Total number of products for this brand whose status an admin\/editor can browse to (excludes only the brand-placeholder status). Pre-computed by the brands:update-products-count batch.",
                            ),
                        products_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing products_count — narrower, also excludes draft\/rejected\/dummy\/duplicated statuses a guest can't browse to. Pre-computed by the brands:update-products-count batch (ISS-01-190).",
                            ),
                        average_rating: zod.number().nullish().describe("Average rating score (null if no ratings)"),
                        activate_time: zod
                            .string()
                            .datetime({ offset: true })
                            .nullish()
                            .describe("Brand activation timestamp (null if not activated)"),
                        priority: zod
                            .union([
                                zod.literal(1),
                                zod.literal(2),
                                zod.literal(3),
                                zod.literal(4),
                                zod.literal(5),
                                zod.literal(9),
                            ])
                            .optional()
                            .describe("Display priority (higher = more prominent)"),
                        country: zod
                            .string()
                            .max(getBrandMergeCandidates200ResponseDataSourceCountryMax)
                            .optional()
                            .describe("Brand origin country"),
                        website: zod
                            .string()
                            .max(getBrandMergeCandidates200ResponseDataSourceWebsiteMax)
                            .optional()
                            .describe("Official brand website URL"),
                        facebook: zod
                            .string()
                            .max(getBrandMergeCandidates200ResponseDataSourceFacebookMax)
                            .optional()
                            .describe("Facebook page username or ID"),
                        instagram: zod
                            .string()
                            .max(getBrandMergeCandidates200ResponseDataSourceInstagramMax)
                            .optional()
                            .describe("Instagram username"),
                        youtube: zod
                            .string()
                            .max(getBrandMergeCandidates200ResponseDataSourceYoutubeMax)
                            .optional()
                            .describe("YouTube channel URL (null if not available)"),
                        tiktok: zod
                            .string()
                            .max(getBrandMergeCandidates200ResponseDataSourceTiktokMax)
                            .optional()
                            .describe("TikTok profile URL (null if not available)"),
                        x: zod
                            .string()
                            .max(getBrandMergeCandidates200ResponseDataSourceXMax)
                            .optional()
                            .describe("X profile URL or username (null if not available)"),
                        brand_video_post_ids: zod
                            .array(zod.number())
                            .nullish()
                            .describe("Post IDs with video\/SNS media linked to this brand (batch-updated pool)"),
                        recommend_rank: zod.number().nullish().describe("Recommend rank (null if not recommended)"),
                    })
                    .strict()
                    .optional(),
                candidates: zod
                    .array(
                        zod
                            .object({
                                brand_id: zod.number().nullable().describe("Unique brand identifier (numeric)"),
                                brand_note: zod
                                    .string()
                                    .optional()
                                    .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
                                brand_index: zod
                                    .string()
                                    .max(getBrandMergeCandidates200ResponseDataCandidatesItemBrandIndexMax)
                                    .describe("Alphabetical index for sorting (0-9, A-Z)"),
                                brand_name: zod
                                    .string()
                                    .max(getBrandMergeCandidates200ResponseDataCandidatesItemBrandNameMax)
                                    .describe("Brand name"),
                                brand_status: zod
                                    .enum(["draft", "editing", "released", "duplicated", "rejected"])
                                    .optional()
                                    .describe("Brand status"),
                                created_by: zod.number().nullish().describe("User ID who created this brand (audit)"),
                                updated_by: zod
                                    .number()
                                    .nullish()
                                    .describe("User ID who last updated this brand (audit)"),
                                created_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Brand created timestamp (audit)"),
                                updated_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Brand last updated timestamp (audit)"),
                                image_url: zod.string().optional().describe("Brand logo image URL"),
                                brand_description_th: zod.string().optional().describe("Brand description in Thai"),
                                brand_description_en: zod.string().optional().describe("Brand description in English"),
                                brand_description_ja: zod.string().optional().describe("Brand description in Japanese"),
                                review_count: zod.number().nullish().describe("Total number of reviews for this brand"),
                                review_count_guest: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Guest-facing review_count — excludes reviews on products a guest can't browse to (draft\/rejected\/dummy\/duplicated\/brand-placeholder, same basis as products_count_guest). Pre-computed by the products:update-stats batch (ISS-01-190).",
                                    ),
                                posts_count: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Total number of posts across all of this brand's products, across all board types (review, articles, tiktoks) — not just reviews. Admin\/editor-facing (unfiltered).",
                                    ),
                                posts_count_guest: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Guest-facing posts_count — excludes posts on products a guest can't browse to (same basis as products_count_guest). Pre-computed by the products:update-stats batch (ISS-01-190).",
                                    ),
                                products_count: zod
                                    .number()
                                    .optional()
                                    .describe(
                                        "Total number of products for this brand whose status an admin\/editor can browse to (excludes only the brand-placeholder status). Pre-computed by the brands:update-products-count batch.",
                                    ),
                                products_count_guest: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Guest-facing products_count — narrower, also excludes draft\/rejected\/dummy\/duplicated statuses a guest can't browse to. Pre-computed by the brands:update-products-count batch (ISS-01-190).",
                                    ),
                                average_rating: zod
                                    .number()
                                    .nullish()
                                    .describe("Average rating score (null if no ratings)"),
                                activate_time: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .nullish()
                                    .describe("Brand activation timestamp (null if not activated)"),
                                priority: zod
                                    .union([
                                        zod.literal(1),
                                        zod.literal(2),
                                        zod.literal(3),
                                        zod.literal(4),
                                        zod.literal(5),
                                        zod.literal(9),
                                    ])
                                    .optional()
                                    .describe("Display priority (higher = more prominent)"),
                                country: zod
                                    .string()
                                    .max(getBrandMergeCandidates200ResponseDataCandidatesItemCountryMax)
                                    .optional()
                                    .describe("Brand origin country"),
                                website: zod
                                    .string()
                                    .max(getBrandMergeCandidates200ResponseDataCandidatesItemWebsiteMax)
                                    .optional()
                                    .describe("Official brand website URL"),
                                facebook: zod
                                    .string()
                                    .max(getBrandMergeCandidates200ResponseDataCandidatesItemFacebookMax)
                                    .optional()
                                    .describe("Facebook page username or ID"),
                                instagram: zod
                                    .string()
                                    .max(getBrandMergeCandidates200ResponseDataCandidatesItemInstagramMax)
                                    .optional()
                                    .describe("Instagram username"),
                                youtube: zod
                                    .string()
                                    .max(getBrandMergeCandidates200ResponseDataCandidatesItemYoutubeMax)
                                    .optional()
                                    .describe("YouTube channel URL (null if not available)"),
                                tiktok: zod
                                    .string()
                                    .max(getBrandMergeCandidates200ResponseDataCandidatesItemTiktokMax)
                                    .optional()
                                    .describe("TikTok profile URL (null if not available)"),
                                x: zod
                                    .string()
                                    .max(getBrandMergeCandidates200ResponseDataCandidatesItemXMax)
                                    .optional()
                                    .describe("X profile URL or username (null if not available)"),
                                brand_video_post_ids: zod
                                    .array(zod.number())
                                    .nullish()
                                    .describe(
                                        "Post IDs with video\/SNS media linked to this brand (batch-updated pool)",
                                    ),
                                recommend_rank: zod
                                    .number()
                                    .nullish()
                                    .describe("Recommend rank (null if not recommended)"),
                            })
                            .strict(),
                    )
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetBrandMergeCandidates401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const GetBrandMergeCandidates403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const GetBrandMergeCandidates500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * Reassigns every child reference (products, brand_recommends, search_suggests, users.frequent_brand_ids) from brand_id (path) to target_id, removes the source's placeholder product, applies the chosen field values onto the target, and appends a merge record to both sides' brand_note. The source brand itself is not deleted.
 * @summary Merge a duplicated brand into a target brand (admin/editor only)
 */
export const MergeBrandParams = zod
    .object({
        brand_id: zod.number().nullable().describe("Source brand ID (the duplicated one being merged away)"),
    })
    .strict();

export const MergeBrandBody = zod
    .object({
        target_id: zod.number(),
        fields: zod
            .record(zod.string(), zod.enum(["source", "target"]))
            .optional()
            .describe(
                'Only fields set to \"source\" are copied onto the target; anything else (including fields not present) keeps the target\'s existing value.',
            ),
    })
    .strict();

export const MergeBrand200Response = zod
    .object({
        data: zod
            .object({
                reassigned: zod.record(zod.string(), zod.number()).optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const MergeBrand401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const MergeBrand403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const MergeBrand404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const MergeBrand422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const MergeBrand500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * Remove all brand recommend entries (bulk clear).
 * @summary Clear all brand recommends (admin/editor only)
 */
export const ClearBrandRecommends200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                brand_id: zod.number().nullable(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const ClearBrandRecommends401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const ClearBrandRecommends403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const ClearBrandRecommends500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

/**
 * @summary Get specific brand by ID
 */
export const GetItemParams = zod
    .object({
        brand_id: zod.number().nullable(),
    })
    .strict();

export const getItem200ResponseDataItemOneBrandIndexMax = 5;

export const getItem200ResponseDataItemOneBrandNameMax = 100;

export const getItem200ResponseDataItemOneCountryMax = 100;

export const getItem200ResponseDataItemOneWebsiteMax = 1024;

export const getItem200ResponseDataItemOneFacebookMax = 1024;

export const getItem200ResponseDataItemOneInstagramMax = 255;

export const getItem200ResponseDataItemOneYoutubeMax = 1024;

export const getItem200ResponseDataItemOneTiktokMax = 1024;

export const getItem200ResponseDataItemOneXMax = 1024;

export const GetItem200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .union([
                        zod
                            .object({
                                brand_id: zod.number().nullable().describe("Unique brand identifier (numeric)"),
                                brand_note: zod
                                    .string()
                                    .optional()
                                    .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
                                brand_index: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneBrandIndexMax)
                                    .describe("Alphabetical index for sorting (0-9, A-Z)"),
                                brand_name: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneBrandNameMax)
                                    .describe("Brand name"),
                                brand_status: zod
                                    .enum(["draft", "editing", "released", "duplicated", "rejected"])
                                    .optional()
                                    .describe("Brand status"),
                                created_by: zod.number().nullish().describe("User ID who created this brand (audit)"),
                                updated_by: zod
                                    .number()
                                    .nullish()
                                    .describe("User ID who last updated this brand (audit)"),
                                created_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Brand created timestamp (audit)"),
                                updated_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Brand last updated timestamp (audit)"),
                                image_url: zod.string().optional().describe("Brand logo image URL"),
                                brand_description_th: zod.string().optional().describe("Brand description in Thai"),
                                brand_description_en: zod.string().optional().describe("Brand description in English"),
                                brand_description_ja: zod.string().optional().describe("Brand description in Japanese"),
                                review_count: zod.number().nullish().describe("Total number of reviews for this brand"),
                                review_count_guest: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Guest-facing review_count — excludes reviews on products a guest can't browse to (draft\/rejected\/dummy\/duplicated\/brand-placeholder, same basis as products_count_guest). Pre-computed by the products:update-stats batch (ISS-01-190).",
                                    ),
                                posts_count: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Total number of posts across all of this brand's products, across all board types (review, articles, tiktoks) — not just reviews. Admin\/editor-facing (unfiltered).",
                                    ),
                                posts_count_guest: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Guest-facing posts_count — excludes posts on products a guest can't browse to (same basis as products_count_guest). Pre-computed by the products:update-stats batch (ISS-01-190).",
                                    ),
                                products_count: zod
                                    .number()
                                    .optional()
                                    .describe(
                                        "Total number of products for this brand whose status an admin\/editor can browse to (excludes only the brand-placeholder status). Pre-computed by the brands:update-products-count batch.",
                                    ),
                                products_count_guest: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Guest-facing products_count — narrower, also excludes draft\/rejected\/dummy\/duplicated statuses a guest can't browse to. Pre-computed by the brands:update-products-count batch (ISS-01-190).",
                                    ),
                                average_rating: zod
                                    .number()
                                    .nullish()
                                    .describe("Average rating score (null if no ratings)"),
                                activate_time: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .nullish()
                                    .describe("Brand activation timestamp (null if not activated)"),
                                priority: zod
                                    .union([
                                        zod.literal(1),
                                        zod.literal(2),
                                        zod.literal(3),
                                        zod.literal(4),
                                        zod.literal(5),
                                        zod.literal(9),
                                    ])
                                    .optional()
                                    .describe("Display priority (higher = more prominent)"),
                                country: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneCountryMax)
                                    .optional()
                                    .describe("Brand origin country"),
                                website: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneWebsiteMax)
                                    .optional()
                                    .describe("Official brand website URL"),
                                facebook: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneFacebookMax)
                                    .optional()
                                    .describe("Facebook page username or ID"),
                                instagram: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneInstagramMax)
                                    .optional()
                                    .describe("Instagram username"),
                                youtube: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneYoutubeMax)
                                    .optional()
                                    .describe("YouTube channel URL (null if not available)"),
                                tiktok: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneTiktokMax)
                                    .optional()
                                    .describe("TikTok profile URL (null if not available)"),
                                x: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneXMax)
                                    .optional()
                                    .describe("X profile URL or username (null if not available)"),
                                brand_video_post_ids: zod
                                    .array(zod.number())
                                    .nullish()
                                    .describe(
                                        "Post IDs with video\/SNS media linked to this brand (batch-updated pool)",
                                    ),
                                recommend_rank: zod
                                    .number()
                                    .nullish()
                                    .describe("Recommend rank (null if not recommended)"),
                            })
                            .strict(),
                        zod.null(),
                    ])
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetItem400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(404), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();

export const GetItem404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(404), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();

export const GetItem500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(404), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Update brand (admin/editor only)
 */
export const UpdateItemParams = zod
    .object({
        brand_id: zod.number().nullable(),
    })
    .strict();

export const updateItemBodyBrandNameMax = 100;

export const updateItemBodyBrandStatusDefault = `draft`;
export const updateItemBodyBrandIndexMax = 5;

export const updateItemBodyImageUrlMax = 1024;

export const updateItemBodyCountryMax = 100;

export const updateItemBodyWebsiteMax = 1024;

export const updateItemBodyFacebookMax = 1024;

export const updateItemBodyInstagramMax = 255;

export const updateItemBodyYoutubeMax = 1024;

export const updateItemBodyTiktokMax = 1024;

export const updateItemBodyXMax = 1024;

export const updateItemBodyPriorityDefault = 2;

export const UpdateItemBody = zod
    .object({
        brand_name: zod.string().max(updateItemBodyBrandNameMax).optional(),
        brand_status: zod
            .enum(["draft", "editing", "released", "duplicated", "rejected"])
            .default(updateItemBodyBrandStatusDefault)
            .describe("Brand status"),
        brand_index: zod.string().max(updateItemBodyBrandIndexMax).optional(),
        brand_note: zod
            .string()
            .optional()
            .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
        image_url: zod.string().max(updateItemBodyImageUrlMax).optional(),
        country: zod.string().max(updateItemBodyCountryMax).optional(),
        website: zod.string().max(updateItemBodyWebsiteMax).optional(),
        facebook: zod.string().max(updateItemBodyFacebookMax).optional(),
        instagram: zod.string().max(updateItemBodyInstagramMax).optional(),
        youtube: zod.string().max(updateItemBodyYoutubeMax).optional(),
        tiktok: zod.string().max(updateItemBodyTiktokMax).optional(),
        x: zod.string().max(updateItemBodyXMax).optional(),
        priority: zod
            .union([zod.literal(1), zod.literal(2), zod.literal(3), zod.literal(4), zod.literal(5), zod.literal(9)])
            .default(updateItemBodyPriorityDefault),
        activate_time: zod.string().datetime({ offset: true }).nullish(),
        brand_description_th: zod.string().optional(),
        brand_description_en: zod.string().optional(),
        brand_description_ja: zod.string().optional(),
    })
    .strict();

export const updateItem200ResponseDataItemBrandIndexMax = 5;

export const updateItem200ResponseDataItemBrandNameMax = 100;

export const updateItem200ResponseDataItemCountryMax = 100;

export const updateItem200ResponseDataItemWebsiteMax = 1024;

export const updateItem200ResponseDataItemFacebookMax = 1024;

export const updateItem200ResponseDataItemInstagramMax = 255;

export const updateItem200ResponseDataItemYoutubeMax = 1024;

export const updateItem200ResponseDataItemTiktokMax = 1024;

export const updateItem200ResponseDataItemXMax = 1024;

export const UpdateItem200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .object({
                        brand_id: zod.number().nullable().describe("Unique brand identifier (numeric)"),
                        brand_note: zod
                            .string()
                            .optional()
                            .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
                        brand_index: zod
                            .string()
                            .max(updateItem200ResponseDataItemBrandIndexMax)
                            .describe("Alphabetical index for sorting (0-9, A-Z)"),
                        brand_name: zod.string().max(updateItem200ResponseDataItemBrandNameMax).describe("Brand name"),
                        brand_status: zod
                            .enum(["draft", "editing", "released", "duplicated", "rejected"])
                            .optional()
                            .describe("Brand status"),
                        created_by: zod.number().nullish().describe("User ID who created this brand (audit)"),
                        updated_by: zod.number().nullish().describe("User ID who last updated this brand (audit)"),
                        created_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Brand created timestamp (audit)"),
                        updated_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Brand last updated timestamp (audit)"),
                        image_url: zod.string().optional().describe("Brand logo image URL"),
                        brand_description_th: zod.string().optional().describe("Brand description in Thai"),
                        brand_description_en: zod.string().optional().describe("Brand description in English"),
                        brand_description_ja: zod.string().optional().describe("Brand description in Japanese"),
                        review_count: zod.number().nullish().describe("Total number of reviews for this brand"),
                        review_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing review_count — excludes reviews on products a guest can't browse to (draft\/rejected\/dummy\/duplicated\/brand-placeholder, same basis as products_count_guest). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        posts_count: zod
                            .number()
                            .nullish()
                            .describe(
                                "Total number of posts across all of this brand's products, across all board types (review, articles, tiktoks) — not just reviews. Admin\/editor-facing (unfiltered).",
                            ),
                        posts_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing posts_count — excludes posts on products a guest can't browse to (same basis as products_count_guest). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        products_count: zod
                            .number()
                            .optional()
                            .describe(
                                "Total number of products for this brand whose status an admin\/editor can browse to (excludes only the brand-placeholder status). Pre-computed by the brands:update-products-count batch.",
                            ),
                        products_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing products_count — narrower, also excludes draft\/rejected\/dummy\/duplicated statuses a guest can't browse to. Pre-computed by the brands:update-products-count batch (ISS-01-190).",
                            ),
                        average_rating: zod.number().nullish().describe("Average rating score (null if no ratings)"),
                        activate_time: zod
                            .string()
                            .datetime({ offset: true })
                            .nullish()
                            .describe("Brand activation timestamp (null if not activated)"),
                        priority: zod
                            .union([
                                zod.literal(1),
                                zod.literal(2),
                                zod.literal(3),
                                zod.literal(4),
                                zod.literal(5),
                                zod.literal(9),
                            ])
                            .optional()
                            .describe("Display priority (higher = more prominent)"),
                        country: zod
                            .string()
                            .max(updateItem200ResponseDataItemCountryMax)
                            .optional()
                            .describe("Brand origin country"),
                        website: zod
                            .string()
                            .max(updateItem200ResponseDataItemWebsiteMax)
                            .optional()
                            .describe("Official brand website URL"),
                        facebook: zod
                            .string()
                            .max(updateItem200ResponseDataItemFacebookMax)
                            .optional()
                            .describe("Facebook page username or ID"),
                        instagram: zod
                            .string()
                            .max(updateItem200ResponseDataItemInstagramMax)
                            .optional()
                            .describe("Instagram username"),
                        youtube: zod
                            .string()
                            .max(updateItem200ResponseDataItemYoutubeMax)
                            .optional()
                            .describe("YouTube channel URL (null if not available)"),
                        tiktok: zod
                            .string()
                            .max(updateItem200ResponseDataItemTiktokMax)
                            .optional()
                            .describe("TikTok profile URL (null if not available)"),
                        x: zod
                            .string()
                            .max(updateItem200ResponseDataItemXMax)
                            .optional()
                            .describe("X profile URL or username (null if not available)"),
                        brand_video_post_ids: zod
                            .array(zod.number())
                            .nullish()
                            .describe("Post IDs with video\/SNS media linked to this brand (batch-updated pool)"),
                        recommend_rank: zod.number().nullish().describe("Recommend rank (null if not recommended)"),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const UpdateItem401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpdateItem403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpdateItem404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpdateItem409Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpdateItem422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpdateItem500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * @summary Delete brand (admin/editor only)
 */
export const DeleteItemParams = zod
    .object({
        brand_id: zod.number().nullable(),
    })
    .strict();

export const deleteItemQueryCascadeDefault = false;

export const DeleteItemQueryParams = zod
    .object({
        cascade: zod
            .boolean()
            .default(deleteItemQueryCascadeDefault)
            .describe(
                "When true, also delete every product owned by this brand and every post linked to those products, instead of the default 409 block when the brand still has products\/posts (ISS-04 brand delete confirm dialog).",
            ),
    })
    .strict();

export const DeleteItem200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                deleted: zod.boolean().optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const DeleteItem401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const DeleteItem403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const DeleteItem404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const DeleteItem409Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const DeleteItem500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * @summary Upload brand logo image (admin/editor only)
 */
export const UploadBrandImageParams = zod
    .object({
        brand_id: zod.number().describe("Brand ID"),
    })
    .strict();

export const UploadBrandImageBody = zod
    .object({
        brand_image: zod.instanceof(File),
    })
    .strict();

export const UploadBrandImage200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                image_url: zod.string().optional(),
                filename: zod.string().nullish(),
                message: zod.string().nullish(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const UploadBrandImage401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UploadBrandImage403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UploadBrandImage404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UploadBrandImage422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UploadBrandImage500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * Every brand has exactly one non-purchasable placeholder product (see BrandPlaceholderProductHelper / ISS-01-146). Used by the Target Product Search picker's "brand found, no matching product" fallback (ISS-02-209) to let a review be linked to the brand itself.
 * @summary Get the brand's product_status=brand placeholder product
 */
export const GetBrandPlaceholderProductParams = zod
    .object({
        brand_id: zod.number().describe("Brand ID"),
    })
    .strict();

export const GetBrandPlaceholderProduct200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                product_id: zod.number(),
                product_name: zod.string(),
                brand_id: zod.number(),
                brand_name: zod.string(),
                image_url: zod.string().nullable(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetBrandPlaceholderProduct404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const GetBrandPlaceholderProduct500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();
